import { ReviewEduContentContainer } from 'modules/ReviewEducationalContent'
import React from 'react'

type Props = {}

const ReviewEducationContent = (props: Props) => {
    return (
        <ReviewEduContentContainer />
    )
}

export default ReviewEducationContent